<vl-region>
    <div v-vl-align:center v-if="loading">
        <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b." />
    </div>
    <vl-form-grid mod-stacked v-if="!loading">
        <vl-column>
            <vl-title tag-name="h2">
                {{title}}
            </vl-title>
        </vl-column>
        <vl-column>
            <div>
                Elke 25e van de maand sturen we automatisch een e-mail naar alle organisaties die
                een 'Eigen referentie' ingesteld hebben bij hun facturatiegegevens in KLIP. In deze e-mail vragen we
                om hun facturatiegegevens (eigen referentie, t.a.v. en e-mailadres) na te kijken en indien nodig aan te
                passen voor de 6de van de maand.
            </div>
        </vl-column>
        <vl-column v-if="roundSuccessfullyDone">
            <vl-alert v-if="!hasErrors" icon="check" title="Facturatie ronde afgelopen!" mod-success>
                <div v-if="!!currentInvoiceRound.endTime">De facturatieronde die gestart is op
                    {{formatDate(currentInvoiceRound.startTime)}} is succesvol afgelopen op
                    {{formatDate(currentInvoiceRound.endTime)}}.</div>
                <div v-else>De facturatieronde die gestart is op {{formatDate(currentInvoiceRound.startTime)}} is
                    succesvol afgelopen.</div>
            </vl-alert>
            <vl-alert v-else icon="alert-circle" title="Facturatie ronde afgelopen!" mod-error>
                <div v-if="!!currentInvoiceRound.endTime">De facturatieronde die gestart is op {{formatDate(currentInvoiceRound.startTime)}} is met fouten afgelopen op {{formatDate(currentInvoiceRound.endTime)}}. Facturatie werd niet uitgevoerd.</div>
                <div v-else>De facturatieronde die gestart is op {{formatDate(currentInvoiceRound.startTime)}} is met fouten afgelopen.</div>
            </vl-alert>
            <vl-u-spacer mod-medium />
        </vl-column>
        <vl-column v-if="nothingToInvoice">
            <vl-alert icon="check" title="Niks te factureren!" mod-success>
                <div>De facturatieronde heeft geen te factureren aanvragen.</div>
            </vl-alert>
            <vl-u-spacer mod-medium />
        </vl-column>

        <vl-column v-if="error">
            <vl-alert mod-error icon="alert-circle" title="Fout tijdens het starten van de facturatie!"
                :closable="false">
                <p>
                    {{error}}
                </p>
            </vl-alert>
            <vl-u-spacer mod-medium />
        </vl-column>
        <vl-column v-kl-u-background-alt v-if="!invoiceFormVisible && roundSuccessfullyDone">
            <vl-grid v-kl-u-box-padding>
                <vl-column width="7">
                    <strong>Volgende geplande facturatieronde</strong>
                    <div>{{next6thDay}} 03u00 UTC (= 4u bij wintertijd, 5u bij zomertijd)</div>
                    <vl-u-spacer mod-small />
                    <div v-if="!!mapRequestsNotRegisteredInFinancialTransaction &&
                            mapRequestsNotRegisteredInFinancialTransaction.length > 0">
                        <div><strong>LET OP!</strong> Er zijn {{mapRequestsNotRegisteredInFinancialTransaction.length}}
                            planaanvragen die nog
                            <kl-router-link :to="routeAdminMapRequestWithFinancialAnomalies" class="vl-link">
                                niet binnen Clearing House geregistreerd zijn.
                            </kl-router-link>
                        </div>
                    </div>
                </vl-column>
                <vl-column width="2">
                    <strong><vl-button @click="showInvoiceFormDryRun" mod-secondary :mod-disabled="startingNewRound"
                                       mod-large>
                       Enkel Dry-run
                    </vl-button>
                    </strong>
                </vl-column>
                <vl-column width="3">
                    <strong><vl-button @click="showInvoiceForm" mod-primary :mod-disabled="startingNewRound"
                            mod-large>
                            Manuele facturatie starten
                        </vl-button>
                    </strong>
                </vl-column>
            </vl-grid>
        </vl-column>
        <vl-column v-kl-u-background-alt v-if="!invoiceFormVisible && roundSuccessfullyDone">
            <vl-grid v-kl-u-box-padding>
                <vl-column>
                    <strong>Vorige facturatieronde</strong>
                    <div v-if="!!currentInvoiceRound.endTime">
                        <div>Gestart op {{formatDate(currentInvoiceRound.startTime)}}.</div>
                        <div>Afgerond op {{formatDate(currentInvoiceRound.endTime)}}.</div>
                    </div>
                    <div v-else>De facturatieronde die gestart is op {{formatDate(currentInvoiceRound.startTime)}} is
                        succesvol afgelopen.</div>
                </vl-column>
            </vl-grid>
        </vl-column>
        <vl-column>
            <vl-form-grid mod-stacked v-kl-u-background-alt v-kl-u-box-padding>
                <vl-column width-l="12" v-if="noActiveRoundRunning && invoiceFormVisible">
                    <form class="kl-start-invoicing vl-form" @submit="onSubmit">
                        <vl-column width-s="12" width-m="8" width-l="12">
                            <strong v-if="dryRunOnly">Enkel DryRun</strong>
                            <strong v-else>Manuele facturatie</strong>
                            <vl-u-spacer mod-small />
                        </vl-column>
                        <vl-column width-s="12" width-m="8" width-l="12" v-if="!isBeta">
                            <strong>Te factureren organisaties:</strong>
                            <vl-u-spacer mod-small />
                        </vl-column>
                        <vl-column v-else>
                            <vl-alert icon="warning" title="Op beta kan alleen een facturatieronde voor het Vlaams Datanutsbedrijf gestart worden." mod-warning>
                            </vl-alert>
                            <vl-u-spacer mod-small />
                        </vl-column>
                        <vl-column width-s="12" width-m="8" width-l="12" v-if="!isBeta">
                            <vl-radio id="organisation-all" name="organisation" :mod-disabled="isSending"
                                v-model="selectedOrganisationTpe" value="all" checked>Alle organisaties
                            </vl-radio>
                            <vl-radio id="organisation-select" name="organisation" :mod-disabled="isSending"
                                v-model="selectedOrganisationTpe" value="select">Selecteer de organisatie(s)
                            </vl-radio>
                            <vl-u-spacer />
                        </vl-column>
                        <vl-column width-s="12" width-m="12" width-l="12" v-if="organisationSelection">
                            <kl-search-organisation v-model="selectedOrganisations" :single="false" :only-include-root-organisations="true" />
                            <vl-u-spacer mod-small />
                        </vl-column>
                        <vl-column width="4">
                            <kl-field-validation-wrapper-yup :field="fields.dateFrom" #default="{hasErrors}" mod-required>
                                <kl-datepicker :mod-error="hasErrors" v-model="dateFrom" :max-date="dateFromMaxDate" />
                            </kl-field-validation-wrapper-yup>
                            <vl-u-spacer />
                        </vl-column>
                        <vl-column v-if="!dryRunOnly">
                            <vl-checkbox  v-model="overruleDryRun" ref="overruleCheckbox">
                                Toch doorgaan indien de dry run fouten bevat
                            </vl-checkbox>
                        </vl-column>
                        <vl-button type="submit" :mod-disabled="disableSubmit" mod-large>Start</vl-button>
                    </form>
                </vl-column>
                <template v-if="!startingNewRound">
                    <vl-column>
                        <div class="log">
                            <div v-for="log in currentInvoiceRound.log" :class="logClass(log)">
                                <span>{{formatDate(log.timestamp)}}</span> - <span v-html="log.message"></span>
                            </div>
                        </div>
                    </vl-column>
                </template>
            </vl-form-grid>
        </vl-column>
    </vl-form-grid>
</vl-region>
